<input
    #input
    type="text"
    matInput
    [matAutocomplete]="autocomplete"
    (input)="onInput($event.target.value)"
    [matChipInputFor]="chipList"
    [disabled]="disabled" 
    placeholder="{{ 'global.start_typing' | translate }}" 
    (focusout)="onFocusOut()"
    (focusin)="onFocusIn()"/>

@if (value?.length) {
    <hr class="my-2"/>
}

<mat-chip-grid #chipList class="px-4" (focusin)="onFocusIn()" 
    (focusout)="onFocusOut()">

    @if (value?.length) {

        @for (element of value; track element) {
            <mat-chip-row
                (removed)="onElementRemoved(element)">

                <span>{{ element.name }}</span>
                <button tag="button" matChipRemove class="text-black">
                <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
        }
    }

</mat-chip-grid>

<mat-autocomplete #autocomplete="matAutocomplete" (optionSelected)="clear()">
    
    @for (element of filtered; track element) {
        <mat-option 
            [value]="element.id"
            (onSelectionChange)="onElementSelected(element)">
            <span>{{ element.name }}</span>
        </mat-option>
    }
    
</mat-autocomplete>